import { Alert, AlertProps, AlertTitle, Box } from '@mui/material';

interface CustomAlertProps extends Omit<AlertProps, 'title'> {
    title?: string;
    message: string;
    gridProps?: {
        xs?: number;
        spacing?: number;
        sx?: object;
    };
}


export const BoxAlert: React.FC<Omit<CustomAlertProps, 'gridProps'> & { boxProps?: { sx?: object;[key: string]: any } }> = ({
    title,
    message,
    boxProps = { sx: { pb: '16px' } },
    ...alertProps
}) => {
    return (
        <Box {...boxProps}>
            <Alert {...alertProps} sx={{
                padding: '2px 8px 2px 8px',
            }}>
                {title && <AlertTitle>{title}</AlertTitle>}
                {message}
            </Alert>
        </Box>
    );
};

export default BoxAlert;
